import type { ReactNode } from 'react';

export enum DataBuilderPaths {
  CHOOSE = 'choose',
  SAVED_DATASETS = 'saved-datasets',
  DATASET = 'dataset',
  COLUMNS = 'columns',
  DELIVERY = 'delivery',
  CONFIRMATION = 'confirmation',
}

export type DataBuilderStepConfig = {
  id: string;
  path: DataBuilderPaths;
  title: string;
  description?: ReactNode;
};

export const DATA_BUILDER_STEPS: DataBuilderStepConfig[] = [
  { id: 'dataset', path: DataBuilderPaths.DATASET, title: 'Datasets' },
  {
    id: 'columns_and_filters',
    path: DataBuilderPaths.COLUMNS,
    title: 'Columns & Filters',
  },
  { id: 'delivery', path: DataBuilderPaths.DELIVERY, title: 'Delivery' },
  {
    id: 'confirmation',
    path: DataBuilderPaths.CONFIRMATION,
    title: 'Confirmation',
  },
];
